import { gql } from 'graphql-request'

export const SubmitSpeciGql = gql`
  mutation submitSpeci($speciId: UUID!) {
    submitSpeci(request: { speciId: $speciId }) {
      errorMessage
      success
    }
  }
`
